import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import "../assets/css/LogIn.css";
import "../assets/css/Register.css";
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import routes from "routes.js";
import { ReactComponent as Logo } from "../assets/img/logo1.svg";

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 992);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div
        style={{ background: "#0f172a", minHeight: "100vh" }}
        className="main-content"
        ref={mainContent}
      >

        <Container fluid className="d-flex align-items-center" style={{ minHeight: "100vh" }}>
          <Row className="w-100 justify-content-center align-items-center">
            {/* Αριστερή πλευρά */}
            <Col
              lg="6" md="12" sm="12" xs="12" xl="6" xxl="6"
              className="text-center mb-5 mb-md-0"
            >
              <Logo className="LogoStartScreen" />
              <h1
                style={{
                  background:
                    "#5e72e4",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "48px",
                }}
              >
                Welcome to DaSA
              </h1>
              <p
                style={{
                  background:
                    "#5e72e4",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "18 px",
                }}
              >
                Unlock your potential. <br />
                Explore the world of Computer Science<br />
                and Data Structures.
              </p>
            </Col>

            {/* Δεξιά πλευρά → το Login */}
            <Col lg="12" md="12" sm="12" xs="12" xl="6" xxl="6"
              className="register-center"
            >

              <Routes>
                {getRoutes(routes)}
                <Route
                  path="*"
                  element={<Navigate to="/auth/login" replace />}
                />
              </Routes>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
